var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashCan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 1024 1024",
    className: "icon",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M799.6 386.9H863c7.6 0 13.9 6.2 13.9 13.9v29.7c0 7.6-6.2 13.9-13.9 13.9h-63.4v-57.5z",
    fill: "#A4A9AD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M799.6 386.9h29.6v57.5h-29.6z",
    fill: ""
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M223.4 386.9H160c-7.6 0-13.9 6.2-13.9 13.9v29.7c0 7.6 6.2 13.9 13.9 13.9h63.4v-57.5z",
    fill: "#A4A9AD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M193.8 386.9h29.6v57.5h-29.6z",
    fill: ""
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M686.6 214.2h-70.7V158c0-11.7-9.9-21.7-21.7-21.7H428.7c-11.7 0-21.7 9.9-21.7 21.7v56.2h-70.7V158c0-50.9 41.4-92.4 92.4-92.4h165.5c50.9 0 92.4 41.4 92.4 92.4v56.2z",
    fill: "#A4A9AD"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M686.4 151.8H615c0.6 2 0.9 4 0.9 6.2v56.2h70.7V158c0-2.1-0.1-4.1-0.2-6.2zM336.3 158v56.2H407V158c0-2.1 0.3-4.2 0.9-6.2h-71.4c-0.1 2.1-0.2 4.1-0.2 6.2z",
    fill: ""
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M776.4 208.8c0-18.8-15.4-34.2-34.2-34.2H280.8c-18.8 0-34.2 15.4-34.2 34.2v48.9c0 18.8 15.4 34.2 34.2 34.2h461.4c18.8 0 34.2-15.4 34.2-34.2v-48.9z",
    fill: "#D1D3D3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M775.7 202.1H247.2c-0.4 2.2-0.7 4.4-0.7 6.7v48.9c0 18.8 15.4 34.2 34.2 34.2h461.4c18.8 0 34.2-15.4 34.2-34.2v-48.9c0.1-2.3-0.1-4.5-0.6-6.7z",
    fill: ""
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M211.5 301.2v606.6c0 28.7 23.5 52.1 52.1 52.1h495.7c28.7 0 52.1-23.5 52.1-52.1V301.2H211.5z",
    fill: "#D1D3D3"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M211.5 878.8v29c0 28.7 23.5 52.1 52.1 52.1h495.7c28.7 0 52.1-23.5 52.1-52.1v-29H211.5zM211.5 301.2h600v74.2h-600z",
    fill: ""
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M852.3 263.7c0-18.8-15.4-34.2-34.2-34.2H204.9c-18.8 0-34.2 15.4-34.2 34.2v35.2c0 18.8 15.4 34.2 34.2 34.2h613.2c18.8 0 34.2-15.4 34.2-34.2v-35.2zM511.5 818.1c-19.5 0-35.4-15.8-35.4-35.4V451c0-19.5 15.8-35.4 35.4-35.4s35.4 15.8 35.4 35.4v331.8c-0.1 19.5-15.9 35.3-35.4 35.3zM348 818.1c-19.5 0-35.4-15.8-35.4-35.4V451c0-19.5 15.8-35.4 35.4-35.4 19.5 0 35.4 15.8 35.4 35.4v331.8c0 19.5-15.9 35.3-35.4 35.3zM674.9 818.1c-19.5 0-35.4-15.8-35.4-35.4V451c0-19.5 15.8-35.4 35.4-35.4 19.5 0 35.4 15.8 35.4 35.4v331.8c0 19.5-15.8 35.3-35.4 35.3z",
    fill: "#A4A9AD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashCan);
export default __webpack_public_path__ + "static/media/trash-can.a0d676aeb89d8fb975fbd2cba51d9c82.svg";
export { ForwardRef as ReactComponent };